import { Validator } from '@vista-digital/validator';
import { defaultFormConfig, formConfigValidatorSchema } from '../../../subcomponents/form/form/types/config';
import { customerDetailsFormValidationConfigValidator, defaultCustomerDetailsFormValidationConfig } from './validation-config';
export const defaultCustomerDetailsFormConfig = {
    submitButton: Object.assign(Object.assign({}, defaultFormConfig.submitButton), { show: false }),
    cancelButton: Object.assign(Object.assign({}, defaultFormConfig.cancelButton), { show: false }),
    validation: defaultCustomerDetailsFormValidationConfig
};
export const customerDetailsFormConfigValidator = Validator.object(Object.assign(Object.assign({}, formConfigValidatorSchema), { validation: customerDetailsFormValidationConfigValidator }));
